(ns storrito.instagram.story.editor.location-search
  (:require [cljs.core.async :refer [<!]]
            [app.util.api-request :as api])
  (:require-macros [cljs.core.async.macros :refer [go]]))

(defn search-locations
  [{:keys [lat lng query]}]
  (go
    (let [response (<! (api/request {:request-method :post
                                     :url "/api/ig-location-search"
                                     :transit-params {:lat lat
                                                      :lng lng
                                                      :query query}}))]
      (:body response))))
